// Deps
import limiter from "~/modules/limiter";
import { getResourceDetailQuery } from "~/modules/wordpress";
import { getResourceTypeFromPath } from "~/modules/link-parser";

// Components
import ResourceDetail from "~/components/templates/resource/detail";
import ContentContext from "~/context/content";
import Error from "~/pages/_error";

const PostDetailPage = ({ data, error, type }) => {
    if (!data || error) return <Error />;

    return (
        <ContentContext layout="detail" type={type} data={data}>
            <ResourceDetail resource={data} type={type} />
        </ContentContext>
    );
};

PostDetailPage.getInitialProps = async ({ asPath, query }) => {
    // All blog posts have the `blog/` prefix
    let { slug } = query;

    // Determine what resource type we're requesting by the route path base
    const type = getResourceTypeFromPath(asPath);

    try {
        await limiter();

        const res = await getResourceDetailQuery({
            type: type,
            slug: slug
        })();

        const resource = res && res.length ? res[0] : null;

        if (!resource) {
            console.log(`[404]: ${type}, ${asPath}`);
            return { error: 404 };
        }

        return { data: resource, type };
    } catch (e) {
        console.log(`[${e.status}]: ${type}, ${asPath}`);
        return { error: e.status };
    }
};

export default PostDetailPage;
